import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import CopyIcon from '@assets/img/icons/icon-copy.svg?react';
import cn from 'classnames';

import { defaultToastConfig } from '@/common/config/toast';
import { copyToClipboard } from '@/common/lib/copyToClipboard';
import { generateInviteLink } from '@/common/lib/generateInviteLink';
import { SendAnalitics } from '@/common/lib/playdeck';
import { MainButton, SecondaryButton } from '@/components/ui/Button/Button';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';
import { useAppSelector } from '@/redux/store';

import linkPng from '/img/icons/icon-link.png';
import linkWebp from '/img/icons/icon-link.webp';

interface InviteProps {
  className?: string;
}

const Invite: FC<InviteProps> = ({ className }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const refId = useAppSelector((state) => state.user.user?.referral);

  const { inviteLink, fullLink, shareText } = generateInviteLink({ t, refId });

  const inviteFriends = (): void => {
    Telegram.WebApp.openTelegramLink(fullLink);
    SendAnalitics.shareGame({
      placement: location.pathname,
    });
  };

  return (
    <div className={cn('w-full flex items-center gap-1 p-2', className)}>
      <MainButton
        text={t('Invite Friends')}
        onClick={inviteFriends}
        className="flex-1"
        type="button"
      />
      <SecondaryButton
        text=""
        onClick={() => {
          copyToClipboard(inviteLink + '\n' + shareText);
          showToast(
            t('Referral link copied.'),
            { img: linkPng, webp: linkWebp },
            defaultToastConfig,
          );
        }}
        className="!w-auto px-5"
      >
        <CopyIcon className="w-6 h-6 shrink-0" />
      </SecondaryButton>
    </div>
  );
};

export { Invite };
